import script from "./Tcc.vue?vue&type=script&setup=true&lang=js"
export * from "./Tcc.vue?vue&type=script&setup=true&lang=js"

import "./Tcc.vue?vue&type=style&index=0&id=673489dc&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673489dc"]])

export default __exports__